import React from "react";
import { InfinitySpin } from "react-loader-spinner";

export default function NoDataFound() {
  return (
    <div className="flex items-center flex-col">
      <InfinitySpin width="200" color="red" />
      <h3 className="text-xl text-red-500 font-semibold text-center">No Todo Found!</h3>
    </div>
  );
}
